import Backbone from 'backbone';

module.exports = Backbone.Model.extend({
  loading: false,
  readAll: false,
  showChat: false
});
